// extracted by mini-css-extract-plugin
module.exports = {"dot":"StepsDots_dot__LKCw8","dotWrapper":"StepsDots_dotWrapper__9Y7TP"};